"use strict";

require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _commonStore = _interopRequireDefault(require("@audacious/web-common/lib/stores/common-store"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var initialState = {
  data: null,
  error: null,
  isLoading: false
};
var CareTeamsStore = /*#__PURE__*/function (_CommonStore) {
  (0, _inherits2.default)(CareTeamsStore, _CommonStore);
  var _super = _createSuper(CareTeamsStore);
  function CareTeamsStore(dispatcher) {
    (0, _classCallCheck2.default)(this, CareTeamsStore);
    return _super.call(this, dispatcher, initialState);
  }
  (0, _createClass2.default)(CareTeamsStore, [{
    key: "startLoading",
    value: function startLoading() {
      this.setState({
        data: null,
        error: null,
        isLoading: true
      });
    }
  }, {
    key: "finishLoading",
    value: function finishLoading(_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        error = _ref2[0],
        data = _ref2[1];
      this.setState({
        data: data,
        error: error,
        isLoading: false
      });
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.state.isLoading;
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return !(0, _isNil.default)(this.state.data);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.state.data;
    }
  }, {
    key: "getError",
    value: function getError() {
      return this.state.error;
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return CareTeamsStore;
}(_commonStore.default);
CareTeamsStore.storeName = 'CareTeamsStore';
CareTeamsStore.handlers = {
  LOAD_CARE_TEAMS_START: 'startLoading',
  LOAD_CARE_TEAMS_FINISH: 'finishLoading'
};
var _default = CareTeamsStore;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(initialState, "initialState", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/care-teams-store.js");
  reactHotLoader.register(CareTeamsStore, "CareTeamsStore", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/care-teams-store.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/care-teams-store.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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